import { useState, MouseEvent } from 'react'
import { Box, Chip, Popover, Skeleton, Typography, useTheme } from '@mui/material'

import { useUnreviewedScansCount } from 'src/hooks'

import useStyles from './styles'
import { useTranslation } from 'react-i18next'
import { FONTS, SPACES } from 'src/constants'

export const ReviewedCount = () => {
  const [t] = useTranslation()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const theme = useTheme()
  const classes = useStyles({})
  const { data: unreviewedCount, isLoading: isUnreviewedLoading } = useUnreviewedScansCount()

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      {isUnreviewedLoading && (
        <Skeleton className={classes.countLoader} variant="circular" width={20} height={20} />
      )}
      {unreviewedCount && unreviewedCount?.count > 0 && (
        <>
          <Chip
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            size="small"
            className={classes.countBadge}
            label={
              <Typography component={'span'} sx={{ fontSize: '12px' }}>
                {unreviewedCount.count}
              </Typography>
            }
          />
          <Popover
            sx={{ pointerEvents: 'none' }}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
            disableScrollLock
          >
            <Box
              sx={{ padding: SPACES.xxs, textAlign: 'center', maxWidth: '350px', fontSize: '12px' }}
            >
              <Typography
                sx={{
                  fontSize: '12px',
                  color: theme.palette.custom.darkBlue2,
                  fontWeight: FONTS.WEIGHTS.semi_bold,
                }}
              >
                {t('scan-history-unapproved-notification-hover-popup.v')}
              </Typography>
            </Box>
          </Popover>
        </>
      )}
    </>
  )
}
